import { useQuery } from '@tanstack/react-query';
import { api, type BootstrapResponse } from './api';
import { useWorkspace } from './WorkspaceContext';

/**
 * Single shared bootstrap query. All pages read from here; React Query
 * dedupes the in-flight request and caches for the session.
 *
 * `select` is used by callers to project only what they need, avoiding
 * re-renders when unrelated slices change.
 */
export function useBootstrap(enabled = true) {
  const { workspaceId } = useWorkspace();

  return useQuery<BootstrapResponse>({
    queryKey: ['bootstrap', workspaceId],
    queryFn: () => api.bootstrap(workspaceId),
    staleTime: 60_000,
    enabled,
  });
}
